import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import type { OfferBrief, OfferItem } from '@core/offers-types';
import type { Placement } from '@core/placements-types';
import { RequisitionsConfigSelectors } from '@recruitee/requisitions-settings-data';

type Job = OfferItem | OfferBrief;

@Injectable({ providedIn: 'root' })
export class JobOpeningCheckService {
  private areRequisitionsEnabled = this.store.selectSignal(
    RequisitionsConfigSelectors.requisitionsFeatureEnabled,
  );

  constructor(private store: Store) {}

  public hasExceededOpeningLimit(placement: Placement, job: Job): boolean {
    if (!this.areRequisitionsEnabled() || !this.isOfferItem(job)) {
      return false;
    }

    const hiredCandidatesWithOpeningsCount =
      job.hiredCandidatesCount || 0 - job.hiredCandidatesWithoutOpeningsCount;

    return (
      placement.hiredInThisPlacement &&
      !!placement.missingOpening &&
      (job.numberOfOpenings || 0) - hiredCandidatesWithOpeningsCount <= 0
    );
  }

  public isNotAssignedToOpening(placement: Placement, job: Job): boolean {
    if (!this.areRequisitionsEnabled() || !this.isOfferItem(job)) {
      return false;
    }

    const hiredCandidatesWithOpeningsCount =
      job.hiredCandidatesCount - job.hiredCandidatesWithoutOpeningsCount;

    return (
      placement.hiredInThisPlacement &&
      !!placement.missingOpening &&
      hiredCandidatesWithOpeningsCount < (job.numberOfOpenings || 0)
    );
  }

  private isOfferItem(job: Job): job is OfferItem {
    return 'numberOfOpenings' in job;
  }
}
